import React from "react";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

import { getScrollToRoute, scrollWithOffset } from "src/routes/AppRouter";

import { HashLink } from "react-router-hash-link";

type NaveMenuItemProps = {
  section: string;
};

export default function NavMenuItem(props: NaveMenuItemProps) {
  const { section } = props;
  const showMobileMenu = useMediaQuery("(max-width:1070px)");

  return (
    <HashLink
      to={getScrollToRoute(section)}
      smooth
      scroll={(el) => scrollWithOffset(el)}
      style={{ textDecoration: "none" }}
      aria-label={`link to ${section}`}
    >
      <ListItemButton
        className="grow_ellipse"
        sx={{
          width: showMobileMenu ? "100vw" : "auto",
          transition: "all 0.4s ease-out",
          ":hover": {
            transition: "all 0.5s ease",
            backgroundColor: "#0CD6FF",
            "& .linkText": {
              color: "text.dark",
            },
          },
        }}
        component="button"
      >
        <ListItemText
          primary={
            <Typography
              className="linkText"
              variant={showMobileMenu ? "h5" : "body1"}
              component="h5"
              sx={{
                color: "text.primary",
                fontSize: showMobileMenu ? 26 : 18,
                fontWeight: "fontWeightBold",
              }}
            >
              {section}
            </Typography>
          }
        />
      </ListItemButton>
    </HashLink>
  );
}
